require("reactn").setGlobal({ sidebarIsOpen: false })
